// Приостановка кода в режиме async|await
export const pause = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))